import moment from "moment";

// 时间过滤器 转换年月
export const dateYM = (input) => {
  return moment(input).format("YYYY年MM月");
};

// 时间过滤器 转换日
export const dateD = (input) => {
  return moment(input).format("DD");
};

// 时间过滤器 转换年月日
export const dateYMD = (input) => {
  return moment(input).format("YYYY年MM月DD日");
};
// 时间过滤器 转换年月日
export const dateYMDHms = (input) => {
  return moment(input).format("YYYY-MM-DD HH:mm:ss");
};

// 时间过滤器 自定义
export const dateSy = (input, value) => {
  if (input) return moment(input).format(value);
  else return '未定时间'
};

// 小写转大写过滤器
export const datesmall = (value) => {
  if (!value) return ""; // 当传入的value为null，则返回空字符串
  value = value.toString(); // 将传入的value转为String类型
  return value.toUpperCase();
};
